module.exports = __webpack_public_path__ + "static/media/instagram_circle.5a6e6653.png";